export default __webpack_public_path__ + "static/media/_somaliland.a01c2ac5.ico";